import axios from "axios";
import { getApiConfig } from "./config.js";

export const APISignUp = async (adminData, setLoading) => {
    setLoading(true);

    try {
        const apiConfig = getApiConfig();
        const result = await axios.post(`${apiConfig.baseURL}/admin/signup`, adminData, {
            headers: apiConfig.headers
        });

        return result
    } catch (error) {
        console.error('Error signing up: ', error);
        return error;
    } finally {
        setLoading(false);
    }
}

export const APIVerifyEmail = async (verificationData, setLoading) => {
    setLoading(true);

    try {
        const apiConfig = getApiConfig();
        const result = await axios.post(`${apiConfig.baseURL}/admin/verify`, verificationData, {
            headers: apiConfig.headers
        });

        return result
    } catch (error) {
        console.error('Error Verifying email: ', error);
        return error
    } finally {
        setLoading(false);
    }
}

export const APIResendVerificationEmail = async(email, setLoading) => {
    setLoading(true);

    try {
        const apiConfig = getApiConfig();
        const result = await axios.get(`${apiConfig.baseURL}/admin/resend-verification/${email}`, {
            headers: apiConfig.headers
        });

        return result
    } catch (error) {
        console.error('Error Resending Verification email: ', error);
        return error
    } finally {
        setLoading(false);
    }
}